export class AwardsGallery {
    /**
     * @type {HTMLElement}
     */
    target = null;

    /**
     * @type {Object}
     */
    options = {};

    /**
     * @type {string}
     */
    url = '';

    /**
     * @type {string}
     */
    language = 'de';

    /**
     * @type {string}
     */
    imageUrl = '';

    /**
     * @type {boolean}
     */
    editorMode = false;

    constructor(target, options = {}) {
        // Resolve the target element (accepts a selector or an element)
        this.target = typeof target === 'string' ? document.querySelector(target) : target;
        // Merge provided options with defaults
        this.options = Object.assign({}, options);

        // Read data attributes from the target element
        this.url = this.target.dataset.url || '';
        this.language = this.target.dataset.language || 'de';
        this.imageUrl = this.target.dataset.imageUrl || '';
        this.editorMode =
            this.target.dataset.editorMode !== undefined
                ? (this.target.dataset.editorMode === '1')
                : false;

        // If a URL is provided, load the XML data and build the gallery
        if (this.url.trim() !== '') {
            fetch(this.url)
                .then(response => response.text())
                .then(str => {
                    const parser = new DOMParser();
                    /**
                     * @type {Document}
                     */
                    const xml = parser.parseFromString(str, "application/xml");
                    this._build(xml);
                    this._setupHandler();
                })
                .catch(error => console.error('Error loading XML:', error));
        }
        // If in editor mode, still setup the event handlers
        if (this.editorMode !== null) {
            this._setupHandler();
        }
    }

    /**
     *
     * @param {XMLDocument} xml
     * @private
     */
    _build(xml) {
        // Loop through each <entry> element in the XML
        const entries = xml.querySelectorAll('entry');
        entries.forEach(entry => {
            const award = {
                id: entry.querySelector('id') ? entry.querySelector('id').textContent : '',
                produkt: entry.querySelector('id') ? entry.querySelector('id').textContent : '',
                quelle: entry.querySelector('quelle') ? entry.querySelector('quelle').textContent : '',
                ausgabe: entry.querySelector('ausgabe') ? entry.querySelector('ausgabe').textContent : '',
                ueberschrift_de: entry.querySelector('ueberschrift_de') ? entry.querySelector('ueberschrift_de').textContent : '',
                kurzbericht_de: entry.querySelector('kurzbericht_de') ? entry.querySelector('kurzbericht_de').textContent : '',
                ueberschrift_en: entry.querySelector('ueberschrift_en') ? entry.querySelector('ueberschrift_en').textContent : '',
                kurzbericht_en: entry.querySelector('kurzbericht_en') ? entry.querySelector('kurzbericht_en').textContent : '',
                grafiklink: entry.querySelector('grafiklink') ? entry.querySelector('grafiklink').textContent : '',
            };

            // Set a default image if none is provided
            if (!award.grafiklink) {
                award.grafiklink = 'default.png';
            }

            // Select content based on the language
            switch (this.language) {
                default:
                case 'de':
                    award.ueberschrift = award.ueberschrift_de;
                    award.kurzbericht = award.kurzbericht_de;
                    break;
                case 'en':
                    award.ueberschrift = award.ueberschrift_en;
                    award.kurzbericht = award.kurzbericht_en;
                    break;
            }

            // Create the award element container
            const awardElement = document.createElement('div');
            awardElement.classList.add('awards-element');
            awardElement.innerHTML = `
        <div class="awards-element-image">
          <img src="${this.imageUrl}images/${award.grafiklink}" alt=""/>
        </div>
        <div class="awards-element-tooltip">
          <span class="awards-element-tooltip-title">${award.id} ${award.quelle} ${award.ausgabe}</span>
          <div class="awards-element-tooltip-content">
            <p>${award.ueberschrift}</p>
            <div>${award.kurzbericht}</div>
          </div>
        </div>
      `;
            this.target.appendChild(awardElement);
        });

        // Remove the loading message if it exists
        const loadingMessage = this.target.querySelector('.awards-gallery-loading-message');
        if (loadingMessage) {
            loadingMessage.remove();
        }
    }

    _setupHandler() {
        const awardElements = this.target.querySelectorAll('.awards-element');
        awardElements.forEach(element => {
            element.addEventListener('mouseenter', () => {
                const tooltip = element.querySelector('.awards-element-tooltip');
                if (!tooltip) return;

                // Get the parent's dimensions and its position relative to the viewport.
                const containerRect = element.getBoundingClientRect();
                const tooltipWidth = tooltip.offsetWidth;

                // Initially center the tooltip horizontally relative to its parent.
                let desiredLeft = (containerRect.width - tooltipWidth) / 2;
                // Calculate the tooltip's absolute left position if positioned at desiredLeft.
                let absoluteLeft = containerRect.left + desiredLeft;

                // If the tooltip would be cut off on the left side, align it to the left edge.
                if (absoluteLeft < 0) {
                    desiredLeft = 0;
                }
                // If the tooltip would be cut off on the right side, align its right edge with the viewport's right edge.
                else if (absoluteLeft + tooltipWidth > window.innerWidth) {
                    desiredLeft = window.innerWidth - containerRect.left - tooltipWidth;
                }

                // Apply absolute positioning relative to the parent.
                tooltip.style.position = 'absolute';
                tooltip.style.left = `${desiredLeft}px`;

                // Place the tooltip below its image.
                // Adjust the top value if necessary (for example, if the image height differs).
                tooltip.style.top = `${element.offsetHeight}px`;
            });
        });
    }
}
